<template>
    <div>
        <CoreTwoColumnsRow>
            <template #left>
                <CoreBorderWrapper
                    class="flex-grow-1 flex-shrink-1 flex-basis-55"
                    :condensed="true"
                >
                    {{ $t('§contracts.countersigning_date') }}
                </CoreBorderWrapper>
            </template>

            <template #right>
                <CoreDateInput
                    class="flex-grow-1 flex-shrink-1 flex-basis-45"
                    name="countersigning_date"
                    :condensed="true"
                    :disabled="contractStore.saving_countersigning_date"
                    v-model="inputs.countersigning_date"
                />
            </template>
        </CoreTwoColumnsRow>

        <div class="flex justify-start mt-3 gap-2">
            <CoreButton
                icon="pi-save"
                label="§ui_button.save"
                name="saveCountersigningDate"
                :disabled="contractStore.saving_countersigning_date"
                :loading="contractStore.saving_countersigning_date"
                @click="handleSave"
            />

            <CoreButton
                label="§ui_button.cancel"
                name="closeModal"
                variant="tertiary"
                :disabled="contractStore.saving_countersigning_date"
                @click="modalStore.setClose"
                icon="pi-times"
            />
        </div>
    </div>
</template>

<script>
import { useContractStore } from '@/stores/contract'
import { useModalStore } from '@/stores/modal'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreDateInput from '@/components/core/CoreDateInput.vue'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'CountersigningDateModal',

    components: {
        CoreTwoColumnsRow,
        CoreBorderWrapper,
        CoreDateInput,
        CoreButton,
    },

    data() {
        return {
            inputs: {
                countersigning_date: null,
            },
        }
    },

    created() {
        this.contractStore = useContractStore()
        this.modalStore = useModalStore()

        const existing = this.contractStore.contractData.countersigning_date
        if (existing) {
            this.inputs.countersigning_date = new Date(existing)
        }
    },

    methods: {
        formatDate(date) {
            if (!date) return null
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },

        async handleSave() {
            if (!this.contractStore.saving_countersigning_date) {
                const formatted = this.formatDate(this.inputs.countersigning_date)
                await this.contractStore.updateCountersigningDate(formatted)
                this.modalStore.setClose()
            }
        },
    },
}
</script>
